import React, { useEffect } from 'react';
import { locales } from '../../translations/locales';
import translateEntries from '../../controllers/translateEntries';

const ModalAlert = (props) => {
    const { locale, theme, alerts } = props;

    useEffect(() => {
        if (alerts.length > 0) {
            const modalAlert = new window.bootstrap.Modal(document.getElementById('modalAlert'), {
                keyboard: false,
                backdrop: 'static',
            });
            modalAlert.show();
        }
    }, [alerts]);

    return (
        <div>
            <div
                className="modal"
                id="modalAlert"
                data-backdrop="static"
                data-keyboard="false"
                tabIndex="-1"
                aria-labelledby="modalTitle"
                aria-hidden="true"
            >
                <div className='modal-dialog modal-dialog-scrollable modal-dialog-centered'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title' id='modalSocket-Title'>{locales[locale].modals.alert.title}</h5>
                        </div>
                        <div className='modal-body text-center' id='modalAlert-body'>
                            {
                                alerts.map((alert, index) => (
                                    <div key={index} className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                        <h6 className='alert-heading'>
                                            {translateEntries(alert, locale)}
                                        </h6>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='modal-footer' id='modalAlert-footer'>
                            <button type='button' className={`btn btn-${theme === 'DARK' ? 'dark' : 'light'}`} data-dismiss='modal'>
                                {locales[locale].modals.alert.close}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalAlert;
